@if (displayBrowser) {
  <div class="wm-browser" [ngClass]="{'inline': displayInline}" [pTooltip]="getTooltip()" [tooltipPosition]="tooltipLocation">
    @if (displayWithPadding) {
      <div class="wm-browser-padding"></div>
    }
    @if (displayWithSmallerLogo) {
    <div class="wm-browser-logo-smaller"><img [src]="logoUrl" (load)="logoLoaded()"></div>
    } @else {
    <div class="wm-browser-logo"><img [src]="logoUrl" (load)="logoLoaded()"></div>
    }
    @if (!displaySmall) {
      <div class="wm-browser-label">
        @if (showLabels) {
          <div class="wm-browser-label-browser">{{displayBrowser.browserType}} {{displayBrowser.version}}</div>
        }
        @if (showLabels && showPlatform) {
          <div class="wm-browser-label-platform">{{displayBrowser.platform.getFullName()}}</div>
        }
      </div>
    }
    @if (displaySmall) {
      <div class="wm-browser-label" class="wm-browser-small">
        @if (showLabels) {
          <div class="wm-browser-label-browser">{{displayBrowser.shortBrowserType()}} {{displayBrowser.version}}</div>
        }
        @if (showLabels && showPlatform) {
          <div class="wm-browser-label-platform">{{displayBrowser.platform.getFullName()}}</div>
        }
      </div>
    }
    @if (additionalIcon || additionalData) {
      <div class="wm-browser-additional">
        @if (additionalIcon) {
          <div class="wm-browser-additional-icon"><i [ngClass]="additionalIcon" class="fa"></i></div>
        }
        @if (additionalData) {
          <div class="wm-browser-additional-data">{{additionalData}}</div>
        }
      </div>
    }
    @if (displayWithPadding) {
      <div class="wm-browser-padding"></div>
    }
  </div>
}
